export default __webpack_public_path__ + "static/media/Figtree-Regular.e734bd44.ttf";